import { FC } from 'react';
import { createContext, useContext, useState, ReactNode } from 'react';

// User interface for external users
interface ExternalUser {
  id: string;
  name: string;
  email: string;
  avatar?: string;
  company?: string;
  phone?: string;
  city?: string;
  country?: string;
  lastLogin?: string;
  status?: string;
}

interface SelectedUserContextType {
  selectedUser: ExternalUser | null;
  setSelectedUser: (user: ExternalUser | null) => void;
  isUserSelected: boolean;
}

const SelectedUserContext = createContext<SelectedUserContextType | undefined>(undefined);

interface SelectedUserProviderProps {
  children: ReactNode;
}

export const SelectedUserProvider: FC<SelectedUserProviderProps> = ({ children }) => {
  const [selectedUser, setSelectedUser] = useState<ExternalUser | null>(null);

  const value = {
    selectedUser,
    setSelectedUser,
    isUserSelected: !!selectedUser,
  };

  return (
    <SelectedUserContext.Provider value={value}>
      {children}
    </SelectedUserContext.Provider>
  );
};

export const useSelectedUser = (): SelectedUserContextType => {
  const context = useContext(SelectedUserContext);
  if (context === undefined) {
    throw new Error('useSelectedUser must be used within a SelectedUserProvider');
  }
  return context;
};

// Export the ExternalUser type for use in other components
export type { ExternalUser };